export const imageRekognition = async (file: File, url: string) => {
  // Read the file as an ArrayBuffer
  const binaryData = await file.arrayBuffer()

  return fetch(`${url}/image-rekognition`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    body: binaryData
  })
    .then((res) => res.json())
    .then((res) => res)
}

export const searchDataFromText = async (formData, url: string) => {
  return fetch(`${url}/search-data-from-text`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then((res) => res.json())
    .then((res) => res)
}

export const getCarInfo = async (vin: string) => {
  return fetch(`https://tvstuning.com/search/${vin}`)
    .then((res) => res.json())
    .then((res) => res)
}

export const getCountries = async (url: string) => {
  return fetch(`${url}/erpnext?doctype=Country&fields=["name"]&filters=[]&limit=none`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then((res) => res.json())
    .then((res) => res?.data?.map(country => country.name))
}
